import { FieldValue } from "firebase/firestore";

export interface PlansRecord {
  id: string; // Ex: "mensal", "trimestral_promo"
  name: string; // Ex: "Plano Trimestral"
  description: string; // Ex: "Acesso total por 3 meses com 15% de desconto"
  price: number; // Valor em centavos (Ex: 2990 para R$ 29,90)
  currency: string; // Ex: "BRL"
  durationMonths: number; // Quantidade de meses que o plano concede
  active: boolean; // Chave mestra: se false, o front não exibe
  isHighlight?: boolean; // Para destacar o plano "Mais Popular" na UI
  stripePriceId?: string; // Opcional: Se você configurar produtos no dashboard do Stripe
  features: string[]; // Lista de benefícios para exibir no card (ex: ["Fotos ilimitadas", "Ver quem te curtiu"])
  order: number; // Para controlar a ordem de exibição (1, 2, 3...)
  createdAt: FieldValue;
}

export interface PaginatedHistory {
  history: PaymentHistoryItem[];
  lastVisibleId: string | null; // Cursor para a próxima página
  hasMore: boolean;
}

export interface PaymentHistoryItem {
  id: string;
  planId: string;
  amount: number;
  status: "pending" | "succeeded" | "failed";
  paymentMethodType: string;
  boletoUrl: string | null;
  createdAt: { _seconds: number };
}

export interface CreatePaymentRequest {
  amount: number;
  planId: string;
}

type BaseConfirmPaymentRequest = {
  paymentIntentId: string;
  paymentMethodType: "card" | "boleto";
  name?: string;
  email?: string;
  address?: {
    street?: string;
    city?: string;
    state?: string;
    postalCode?: string;
  };
};

export type ConfirmPaymentRequest =
  | (BaseConfirmPaymentRequest & {
      paymentMethodType: "card";
      paymentMethodId: string;
      taxId?: never;
    })
  | (BaseConfirmPaymentRequest & {
      paymentMethodType: "boleto";
      paymentMethodId?: never;
      taxId: string;
    });

export enum PaymentHistoryEnum {
  REQUIRES_ACTION = "requires_action",
  PROCESSING = "processing",
  PENDING = "pending",
  SUCCEEDED = "succeeded",
}
